import { render } from "./World.vue?vue&type=template&id=ed1535ba"
import script from "./World.vue?vue&type=script&lang=js"
export * from "./World.vue?vue&type=script&lang=js"
script.render = render

export default script